import { FlexProps } from '@chakra-ui/react';

export const scrollBarStyle = {
    '&::-webkit-scrollbar': {
        width: '16px',
        borderRadius: '8px',
        backgroundColor: `rgba(0, 0, 0, 0.05)`,
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: `rgba(0, 0, 0, 0.05)`,
    },
};

export const dropZoneStyle = {
    p: '44px',
    dir: 'column',
    bg: 'white',
    border: '1px solid #0F62FE',
    borderRadius: '4px',
};

export const dropZoneMultiStyle = {
    p: '44px',
    dir: 'column',
    bg: 'white',
    border: '1px solid #0F62FE',
    borderBottom: 'none',
    borderTopRightRadius: '4px',
    borderTopLeftRadius: '4px',
};

export const uploadedFileStyle: FlexProps = {
    p: '16px 8px',
    borderY: '1px solid #bfb6b6',
    borderX: '1px solid #bfb6b6',
    borderBottomRadius: '4px',
    boxShadow: 'base',
    bg: 'white',
    direction: 'row',
    justifyContent: 'space-between',
};

export const tableToolbarStyle = {
    bg: 'gray.50',
    p: '16px',
    borderTop: '1px solid',
    borderX: '1px solid',
    borderColor: 'gray.100',
    borderTopRadius: '8px',
    justifyContent: 'flex-start',
};

export const iconTableStyle = {
    variant: 'outline',
    mr: '8px',
};

export const linkStyle = {
    cursor: 'pointer',
    textDecor: 'underline',
    color: 'blue.500',
    mx: '4px',
};

export const generateLinkStyle = (underline = true) => ({
    cursor: 'pointer',
    textDecor: underline ? 'underline' : 'none',
    color: 'blue.500',
    mx: '4px',
});

export const basicLinkStyle = {
    cursor: 'pointer',
    color: 'blue.500',
};

export const tagStyle = {
    variant: 'solid',
    px: '16px',
    py: '4px',
    borderRadius: 'full',
    color: 'white',
    backgroundColor: 'blueMain',
};
